import React, { ReactNode } from 'react';

export interface RadioListProps {
  children?: ReactNode;
}

export default function RadioList({ children }: RadioListProps) {
  return <ul style={{ listStyleType: 'none', padding: 0 }}>{children}</ul>;
}
